<template>
  <div
    data-id="action-buttons"
    class="d-flex"
  >
    <div
      v-for="button in actions"
      :key="button.name"
      class="ml-5"
    >
      <v-btn
        :data-id="button.tagDataId || undefined"
        :small="small"
        class="px-4"
        :class="{'pl-2' : button.create, 'base-hover': outlined}"
        :color="button.color || 'primary'"
        :outlined="outlined(button)"
        :disabled="isDialogAlreadyOpen(button.target) || isActionDisabled(button)"
        :loading="getProcessingStatus(button)"
        v-shortkey="button.shortkey"
        @shortkey.native="checkActionAvailability(button)"
        @click="performAction(button)"
      >
        <Icon
          v-if="button.create"
          name="add"
          size="big"
          :color="iconColor(button.target)"
          class="mr-4"
        />
        {{ getButtonLabel(button) }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getLabelWithShortkey } from '../../const/shortKeys'
import quickActionMixin from '../../mixins/quickActionsMixin.vue'

export default {
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    small: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      userPermissions: state => state.auth.user.permissions
    })
  },
  mixins: [quickActionMixin], // triggerAction, isDialogAlreadyOpen
  methods: {
    getProcessingStatus (action) {
      if (!action.tableName) return false
      return this.$store.state[action.tableName].isProcessing
    },
    getButtonLabel ({ text, shortkey }) {
      return getLabelWithShortkey(text, shortkey?.key)
    },
    outlined (button) {
      return !button.filled && !button.create
    },
    iconColor (target) {
      return this.isDialogAlreadyOpen(target) ? 'gray' : '#37C87A'
    },
    checkActionAvailability (button) {
      if (!this.isDialogAlreadyOpen(button.target)) this.performAction(button)
    },
    performAction (action) {
      this.triggerAction({ action, item: this.item })
    },
    isActionDisabled(action) {
      if (action?.permission && !this.userPermissions.some(permission => permission.name === action.permission)) return true

      if (typeof action.condition === 'function') return !action.condition(this.item)

      switch (action?.condition) {
        case 'hasSelectedItems':
          return this.$store.state[action.tableName].selectedItems.length === 0
        case 'withoutTextConfirmation':
          return this.item?.withoutTextConfirmation
        case 'isNotLoading':
          return this.$store.state[action.tableName].isProcessing
        default:
          return false
      }
    }
  }
}
</script>
